document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.blog-search-input');
  const categoryPills = document.querySelectorAll('.blog-category-pill');
  const articles = document.querySelectorAll('.blog-article');

  // Search functionality
  function filterArticles() {
    const searchTerm = searchInput.value.toLowerCase();
    const activeCategory = document.querySelector('.blog-category-pill.active').dataset.category;

    articles.forEach(article => {
      const title = article.querySelector('.article-card__title').textContent.toLowerCase();
      const excerpt = article.querySelector('.article-card__excerpt').textContent.toLowerCase();
      const tags = article.dataset.tags.split(' ');
      
      const matchesSearch = title.includes(searchTerm) || excerpt.includes(searchTerm);
      const matchesCategory = activeCategory === 'all' || tags.includes(activeCategory);

      article.classList.toggle('hidden', !(matchesSearch && matchesCategory));
    });
  }

  // Category filtering
  categoryPills.forEach(pill => {
    pill.addEventListener('click', () => {
      // Update active state
      categoryPills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      
      filterArticles();
    });
  });

  // Search input handling
  let searchTimeout;
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(filterArticles, 300);
  });
});